export default "/images/d735446390818291dbdf88d9acc360fa.avif";